import { useState } from "react";
import { Grid } from "@material-ui/core";
import HomepageTitle from "./components/homepageTitle";
import InformationBlock from "./components/informationBlock";
import MenuPreview from "./components/menuPreview";
import HomepageHours from "./components/homepageHours";
import ConferenceModal from "./components/conferenceModal";

const Homepage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <Grid container>
      {isModalOpen && <ConferenceModal closeModal={() => setIsModalOpen(false)} />}
      <Grid item xs={12}>
        <HomepageTitle />
        <InformationBlock showHideModal={() => setIsModalOpen(!isModalOpen)} />
        <MenuPreview />
        <HomepageHours />
      </Grid>
    </Grid>
  );
};

export default Homepage;
